// 按模块的action, reducer整合体
// 记录孵化器工作台当前的tab、页码
const WB_TAB_CURRENT = 'WB_TAB_CURRENT';

export function setWbTabCurrent(params) {
  return dispatch => {
    return dispatch({
      type: WB_TAB_CURRENT,
      data: params,
    });
  };
}

export function wbTabCurrent(state = {}, action) {
  switch (action.type) {
    case WB_TAB_CURRENT:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/incubator/wb_tab_current.js